import { Subject } from 'rxjs';

export const changePDLDataSubject = new Subject<any>();
export const changeBulkUploadSubject = new Subject<any>();
export const changeBulkUploadBodyAndHeaderSubject = new Subject<any>();
export const currentJobSubject = new Subject<any>();
